import { render, staticRenderFns } from "./teacherGroup.vue?vue&type=template&id=c79dfe84"
import script from "./teacherGroup.vue?vue&type=script&lang=js"
export * from "./teacherGroup.vue?vue&type=script&lang=js"
import style0 from "./teacherGroup.vue?vue&type=style&index=0&id=c79dfe84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports